import type { ChatMessage } from '../types/chat'

export function utteranceLooksLikeCalendarTimeRetrieval(text: string): boolean {
  const raw = (text || '').trim()
  if (!raw) return false
  return /\b(start\s+time|end\s+time|finish\s+time|what\s+time\s+do\s+i\s+start|what\s+time\s+do\s+i\s+finish|what\s+time\s+do\s+i\s+end|when\s+do\s+i\s+start|when\s+do\s+i\s+finish|when\s+do\s+i\s+end|when\s+is\s+my\s+first\s+appointment|when\s+is\s+my\s+last\s+appointment|let\s+me\s+know\s+my\s+start\s+time|let\s+me\s+know\s+my\s+end\s+time|a\s+quelle\s+heure.*(?:commence|debute|débute|finis|termine)|heure\s+de\s+debut|heure\s+de\s+début|heure\s+de\s+fin)\b/i.test(
    raw,
  )
}

export function utteranceLooksLikeCalendarTimeClarificationAnswer(text: string): boolean {
  const raw = (text || '').trim()
  if (!raw) return false
  return /\b(today|tomorrow|day\s+after\s+tomorrow|aujourd['’]?hui|aujourdhui|demain|apres[-\s]?demain|après[-\s]?demain|\d{1,2}[\/.-]\d{1,2}[\/.-](?:\d{2}|\d{4})|(?:january|janvier|february|fevrier|février|march|mars|april|avril|may|mai|moi|june|juin|july|juillet|august|aout|août|september|septembre|october|octobre|november|novembre|december|decembre|décembre)\s+\d{1,2}|\d{1,2}\s+(?:january|janvier|february|fevrier|février|march|mars|april|avril|may|mai|moi|june|juin|july|juillet|august|aout|août|september|septembre|october|octobre|november|novembre|december|decembre|décembre))\b/i.test(
    raw,
  )
}

export function isCalendarTimeRetrievalFlowInProgress(messages: readonly ChatMessage[]): boolean {
  for (let i = messages.length - 1; i >= 0; i--) {
    const m = messages[i]
    if (m.role !== 'assistant' || m.historySnapshot) continue
    if (m.calendarTimeNeedsDateClarification === true) return true
  }
  return false
}

export function shouldUseHostedChatForCalendarTimeRetrieval(
  text: string,
  messages: readonly ChatMessage[],
): boolean {
  return (
    utteranceLooksLikeCalendarTimeRetrieval(text) ||
    isCalendarTimeRetrievalFlowInProgress(messages) ||
    utteranceLooksLikeCalendarTimeClarificationAnswer(text)
  )
}
